<template>
  <div id="demo-basic-card">
    <div id="dashboard-analytics">
      <div class="vx-row" >
        <div class="vx-col md:w-3/12 vx-card mb-2" style="min-height: 600px;" >
          <div class="p-6 pl-2">
            <span class="title-card-setting ">{{$t('generalSetting')}}</span>
          </div>
          <div class="mt-4">
            <vs-button :class="{click : this.organization}" class="mt-2 btn-style" @click="activeVShow(1)" color="primary" type="border">
              <div class="button-style" >
                <span style="white-space: nowrap">{{$t('generalSettingMenu.btn1')}}</span>
              </div>
            </vs-button>
<!--            <vs-button :class="{click : this.notify}" @click="activeVShow(2)" class="mt-2 btn-style" color="primary" type="border">-->
<!--              <div class="button-style">-->
<!--                <span>{{$t('generalSettingMenu.btn2')}}</span>-->
<!--              </div>-->
<!--            </vs-button>-->
            <!-- <vs-button :class="{click : this.display}" @click="activeVShow(3)" class="mt-2 btn-style" color="primary" type="border">
              <div class="button-style">
                <span>{{$t('generalSettingMenu.btn3')}}</span>
              </div>
            </vs-button> -->
            <vs-button :class="{click : this.ruler}" @click="activeVShow(4)" class="mt-2 btn-style" color="primary" type="border">
              <div class="button-style">
                <span>{{$t('generalSettingMenu.btn4')}}</span>
              </div>
            </vs-button>
            <vs-button :class="{click : this.version}" @click="activeVShow(5)" class="mt-2 btn-style" color="primary" type="border">
              <div class="button-style">
                <span>{{$t('generalSettingMenu.btn5')}}</span>
              </div>
            </vs-button>
            <vs-button :class="{click : this.logout}" @click="activeVShow(6)" class="mt-2 btn-style" color="primary" type="border">
              <div class="button-style">
                <span>{{$t('generalSettingMenu.btn6')}}</span>
              </div>
            </vs-button>
          </div>
        </div>
        <div class="vx-col md:w-9/12 mb-2 w-full">
          <OrganizationInformation v-show="organization"></OrganizationInformation>
          <Display v-show="display"></Display>
          <Notification v-show="notify"/>
          <Rules v-show="ruler"/>
          <Version v-show="version"/>
          <LogOut v-show="logout"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OrganizationInformation from "./OrganizationInformation";
import Notification from "./Notification";
import Display from "./Display";
import Rules from "./Rules";
import Version from "./Version";
import LogOut from "./LogOut";
export default {
  name: "GeneralSettings",
  components:{
    OrganizationInformation,
    Notification,
    Display,
    Rules,
    Version,
    LogOut
  },
  data(){
    return {
      organization:true,
      notify:false,
      display:false,
      version:false,
      ruler:false,
      logout:false
    }
  },
  methods:{
    activeVShow(number){
      switch (number){
        case 1:
          this.display = false;
          this.organization = true;
          this.version = false;
          this.logout = false;
          this.notify = false;
          this.ruler = false;
          break;
        case 2:
          this.display = false;
          this.organization = false;
          this.version = false;
          this.logout = false;
          this.notify = true;
          this.ruler = false;
          break;
        case 3:
          this.display = true;
          this.organization = false;
          this.version = false;
          this.logout = false;
          this.notify = false;
          this.ruler = false;
          break;
        case 4:
          this.display = false;
          this.organization = false;
          this.version = false;
          this.logout = false;
          this.notify = false;
          this.ruler = true;
          break;
        case 5:
          this.display = false;
          this.organization = false;
          this.version = true;
          this.logout = false;
          this.notify = false;
          this.ruler = false;
          break;
        case 6:
          this.display = false;
          this.organization = false;
          this.version = false;
          this.logout = true;
          this.notify = false;
          this.ruler = false;
          break;
      }
    }
  },
  created() {
  }
}
</script>

<style scoped>
.title-card-setting{
  font-weight: bold;
  font-size: 16px;
}
.button-style{
  font-size: 14px;
  font-weight: bold;
}
.btn-style{
  width: 100%;
  display: flex;
  justify-content: flex-start;
  padding: 12px 10px !important;
  border: none;
  color: #626262;
}
.click{
  background-color: #2F80ED !important;
  color: white !important;
}
</style>
